import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import RatePresenterTabContent from "./RatePresenterTabContent";
import Tabs from "../Tabs/Tabs";
import { parseISO } from "date-fns";

export default class RatePresenter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active_tab: this.props.active_tab || "general",
      loading: false,
      numberFormat:
        "0" +
        ($("#delimiter").val() || ",") +
        "0" +
        ($("#separator").val() || ".") +
        "00",
      errors: this.props.errors || [],
      id: this.props.id,
      code: this.props.code || "",
      name: this.props.name || "",
      status: this.props.status,
      rate_type: this.props.rate_type || "",
      is_hidden: this.props.is_hidden || "",
      amount: this.props.amount || "",
      percentage: this.props.percentage || "",
      check_in_time: this.props.check_in_time || null,
      check_out_time: this.props.check_out_time || null,
      short_description: this.props.short_description || "",
      long_description: this.props.long_description || "",
      minimum_stay: this.props.minimum_stay || "",
      maximum_stay: this.props.maximum_stay || "",
      minimum_lead: this.props.minimum_lead || "",
      maximum_lead: this.props.maximum_lead || "",
      start_booking_date: this.props.start_booking_date
        ? parseISO(this.props.start_booking_date)
        : null,
      end_booking_date: this.props.end_booking_date
        ? parseISO(this.props.end_booking_date)
        : null,
      maximum_uses: this.props.maximum_uses || "",
      updated_at: this.props.updated_at,
      taxes: this.props.associated_taxes,
      fees: this.props.associated_fees,
      billing_policy: this.props.billing_policy,
      guest_types: this.props.guest_types || [],
      rate_guest_types: this.props.rate_guest_types || [],
      rate_products: this.props.rate_products || [],
      channel_rate_room_types: this.props.channel_rate_room_types,
      products:
        this.props.products && this.props.products.length
          ? this.props.products
          : [],
      room_types:
        this.props.room_types && this.props.room_types.length
          ? this.props.room_types
          : [],
      seasons: this.props.seasons || [],
    };
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeRevertVersion = this.onChangeRevertVersion.bind(this);
  }

  componentDidMount() {
    var self = this;
    $(window).on("rateSaved", function () {
      $.ajax({
        type: "POST",
        url: `/admin/rates/${self.props.id}/data`,
      }).done((data) => {
      });
    });
  }

  render() {
    return (
      <div className="rate-builder" ref="root">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons
            loading={this.state.loading}
            buttons={this.props.buttons}
          />
          <RatePresenterTabContent
            {...this.state}
            rate_revision_history_path={this.props.rate_revision_history_path}
            date_format={this.props.date_format}
            time_format={this.props.time_format}
          />
        </div>
      </div>
    );
  }

  onChangeActiveTab(active_tab) {
    this.setState({ active_tab: active_tab });
  }

  onChangeRevertVersion() {
    $.ajax({
      type: "POST",
      url: `/admin/rates/${this.props.id}/version/${this.props.version.id}/revert`,
    }).done((data) => {
      window.parent.$(window.parent).trigger("rateSaved");
      this.setState({ loading: false });
      if (parent && parent.refresh_data) {
        // console.log(parent)
        parent.refresh_data(I18n.t("record_reverted_successfully"));
      }
      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }
    });
  }

  tabs() {
    return this.props.historical_view
      ? [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      : [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("billing_policy"),
            targetName: "billing_policy",
            classes:
              this.state.active_tab === "billing_policy" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("products"),
            targetName: "products",
            classes: this.state.active_tab === "products" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("room_types"),
            targetName: "room_types",
            classes: this.state.active_tab === "room_types" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("seasons"),
            targetName: "seasons",
            classes: this.state.active_tab === "seasons" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("taxes_and_fees"),
            targetName: "taxes_and_fees",
            classes:
              this.state.active_tab === "taxes_and_fees" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("channels"),
            targetName: "channels",
            classes: this.state.active_tab === "channels" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("history"),
            targetName: "history",
            classes: this.state.active_tab === "history" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ];
  }
}
